module.exports = __webpack_public_path__ + "img/szafa.c0291b90.jpg";